/* mobile-nav.js — S-tier mobile menu for every page (≤900px).
   Burger opens a full-width editorial panel: serif links with index numbers,
   staggered reveal, scrim + Escape + link-tap close, scroll lock.
   Header stays lean (brand + theme icon + cart + burger) — no overflow;
   the dark/light toggle is an icon button in the header (see dark-mode.js). */
(function () {
  var css = `
  .mn-panel,.mn-scrim{display:none}
  .mn-btn{display:none;position:absolute;left:1.1rem;top:50%;transform:translateY(-50%);width:40px;height:40px;border:1px solid var(--line,rgba(11,11,11,.14));border-radius:2px;background:transparent;color:inherit;z-index:70;place-items:center;cursor:pointer}
  .mn-btn span{display:block;width:16px;height:1.5px;background:currentColor;margin:2.5px auto;transition:all .3s var(--ease,cubic-bezier(.22,1,.36,1))}
  .mn-btn.open span:nth-child(1){transform:translateY(4px) rotate(45deg)}
  .mn-btn.open span:nth-child(2){opacity:0}
  .mn-btn.open span:nth-child(3){transform:translateY(-4px) rotate(-45deg)}
  @media(max-width:900px){
    html,body{overflow-x:clip}
    .mn-btn{display:grid}
    header{position:relative;padding-left:3.6rem}
    header nav{display:none !important}
    .mn-scrim{display:block;position:fixed;inset:0;background:rgba(11,11,11,.32);opacity:0;pointer-events:none;transition:opacity .2s var(--ease,cubic-bezier(.22,1,.36,1));z-index:64}
    .mn-scrim.open{opacity:1;pointer-events:auto}
    .mn-panel{display:flex;position:fixed;left:0;right:0;bottom:0;top:var(--mn-top,60px);z-index:65;
      background:var(--bg,#FBFAF7);color:var(--ink,#0B0B0B);
      display:flex;flex-direction:column;padding:1.6rem 1.5rem 2rem;
      opacity:0;transform:translateY(-10px);pointer-events:none;
      transition:opacity .2s var(--ease,cubic-bezier(.22,1,.36,1)),transform .4s var(--ease,cubic-bezier(.22,1,.36,1));
      overflow-y:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain}
    .mn-panel.open{opacity:1;transform:none;pointer-events:auto}
    .mn-panel a.mn-link{display:flex;align-items:baseline;gap:.9rem;text-decoration:none;color:inherit;
      padding:1.05rem .1rem;border-bottom:1px solid var(--line,rgba(11,11,11,.14));
      font:300 clamp(1.45rem,6vw,1.9rem)/1.15 var(--serif,Georgia,serif);letter-spacing:-.01em;
      opacity:0;transform:translateY(10px);
      transition:opacity .3s var(--ease,cubic-bezier(.22,1,.36,1)),transform .5s var(--ease,cubic-bezier(.22,1,.36,1)),color .2s}
    .mn-panel.open a.mn-link{opacity:1;transform:none}
    .mn-panel a.mn-link:active{color:var(--gold,#B3893F)}
    .mn-panel a.mn-link i{font:800 .6rem/1 var(--sans,"Helvetica Neue",Arial,sans-serif);font-style:normal;letter-spacing:.18em;color:var(--gold,#B3893F);transform:translateY(-.35em)}
    .mn-foot{margin-top:auto;padding-top:1.8rem;display:flex;align-items:center;justify-content:space-between;gap:1rem}
    .mn-foot .mn-cap{font:800 .6rem/1 var(--sans,"Helvetica Neue",Arial,sans-serif);letter-spacing:.18em;text-transform:uppercase;color:var(--ink-3,var(--gray,#8C8C88))}
  }`;
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var MQ = window.matchMedia('(max-width:900px)');
  var header, nav, btn, scrim, panel, foot;

  function closeMenu() {
    if (!panel) return;
    panel.classList.remove('open');
    scrim.classList.remove('open');
    btn.classList.remove('open');
    btn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  function openMenu() {
    panel.classList.add('open');
    scrim.classList.add('open');
    btn.classList.add('open');
    btn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function init() {
    header = document.querySelector('header');
    if (!header) return;
    nav = header.querySelector('nav');
    if (!nav) return;
    if (getComputedStyle(header).position === 'static') header.style.position = 'relative';
    document.documentElement.style.setProperty('--mn-top', header.offsetHeight + 'px');

    // burger
    btn = document.createElement('button');
    btn.className = 'mn-btn';
    btn.setAttribute('aria-label', 'Menu');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span></span><span></span><span></span>';
    btn.addEventListener('click', function () {
      panel.classList.contains('open') ? closeMenu() : openMenu();
    });
    header.appendChild(btn);
    /* owner veto: the dark-mode toggle stays in the header (icon, ≤900px),
       never in the drawer. Burger parks at the far left (classic editorial
       pattern) so it can never collide with toggle/cart or crowd the wordmark —
       the header gets padding-left to make room. */

    // scrim + panel (cloned links — the real nav stays untouched for desktop)
    scrim = document.createElement('div');
    scrim.className = 'mn-scrim';
    scrim.addEventListener('click', closeMenu);
    document.body.appendChild(scrim);

    panel = document.createElement('div');
    panel.className = 'mn-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'Menu');
    var links = nav.querySelectorAll('a');
    links.forEach(function (a, i) {
      var c = document.createElement('a');
      c.className = 'mn-link';
      c.href = a.getAttribute('href');
      c.innerHTML = '<i>' + ('0' + (i + 1)).slice(-2) + '</i>' + a.textContent.trim().toLowerCase();
      c.style.transitionDelay = (i * 45) + 'ms';
      c.addEventListener('click', closeMenu);
      panel.appendChild(c);
    });
    foot = document.createElement('div');
    foot.className = 'mn-foot';
    foot.innerHTML = '<span class="mn-cap">Live Wall Arts</span>';
    panel.appendChild(foot);
    document.body.appendChild(panel);

    /* owner veto: the dark-mode toggle stays in the header (icon, ≤900px),
       never in the drawer — placeBurger() above measures its left edge. */

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });

    window.addEventListener('resize', function () {
      document.documentElement.style.setProperty('--mn-top', header.offsetHeight + 'px');
      if (!MQ.matches) closeMenu();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
